import { ProductOrderItem } from '@api/types';
import { SmartLink, StyledTableRow, StyledTableRowSeparator, TableCell } from '@components';
import { useAppSelector, useAuth } from '@hooks';
import { getSpecialPage } from '@store/app/app.slice';
import {
  productOrderRequestItems,
  productOrderRequestListColumns,
} from './productOrderRequestList.config';

type ProductOrderRequestListRowProps = {
  productOrderRequest: ProductOrderItem;
  isWorking?: boolean;
};

export const ProductOrderRequestListRow: React.FC<ProductOrderRequestListRowProps> = ({
  isWorking,
  productOrderRequest,
}: ProductOrderRequestListRowProps) => {
  const { isBeremaUser } = useAuth();
  const items = productOrderRequestItems({ isBeremaUser, productOrderRequest });
  const productOrderRequestDetailsBaseUrl = useAppSelector(
    getSpecialPage('productOrderRequestDetailsPage')
  ) as string;

  const productOrderRequestDetailsHref = `${productOrderRequestDetailsBaseUrl}?id=${productOrderRequest.id.toString()}`;
  return (
    <StyledTableRow iscursorpointer='true'>
      <SmartLink
        sx={{ display: 'contents', p: 8 }}
        className='link'
        href={productOrderRequestDetailsHref}
      >
        {items.map((item) => (
          <TableCell
            key={item.fieldName}
            isWorking={isWorking}
            filteredColumns={productOrderRequestListColumns(isBeremaUser)}
            visibleColumnNames={productOrderRequestListColumns(isBeremaUser).map((column) =>
              column.key.toLowerCase()
            )}
            searchWords={[]}
            {...item}
          />
        ))}
        <StyledTableRowSeparator />
      </SmartLink>
    </StyledTableRow>
  );
};
